interface PageHeroProps {
  eyebrow?: string;
  title: string;
  description: string;
  bgVariant?: "primary" | "slate" | "teal" | "steel" | "graphite" | "burgundy" | "amber";
  bgImage?: string;
}

const BG_FALLBACK: Record<string, string> = {
  primary: "var(--bg-dark-primary)",
  slate: "var(--bg-dark-slate)",
  teal: "var(--bg-dark-teal)",
  steel: "var(--bg-dark-steel)",
  graphite: "var(--bg-dark-graphite)",
  burgundy: "#1a0a0e",
  amber: "#1e1408",
};

export function PageHero({ eyebrow, title, description, bgVariant = "primary", bgImage }: PageHeroProps) {
  return (
    <section
      className="section section-dark"
      style={{
        paddingTop: "var(--space-12)",
        paddingBottom: "var(--space-10)",
        position: "relative",
        overflow: "hidden",
        background: BG_FALLBACK[bgVariant],
      }}
    >
      {bgImage && (
        <>
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            aria-hidden
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(90deg, rgba(10,22,40,0.82) 0%, rgba(10,22,40,0.55) 45%, rgba(10,22,40,0.25) 100%)",
            }}
            aria-hidden
          />
        </>
      )}
      <div className="container" style={{ position: "relative" }}>
        {eyebrow && (
          <div className="eyebrow eyebrow-dark" style={{ marginBottom: "1rem" }}>
            {eyebrow}
          </div>
        )}
        <h1 style={{ color: "var(--text-on-dark)", marginBottom: "1.25rem", maxWidth: "760px" }}>
          {title}
        </h1>
        <p
          className="lead lead-dark"
          style={{ maxWidth: "680px", fontSize: "1.125rem" }}
        >
          {description}
        </p>
      </div>
    </section>
  );
}
